import { useRouter } from 'next/router'
import Link from 'next/link'
import { Link as PrismicLink } from 'prismic-reactjs'
import linkResolver from '../../helpers/linkResolver'

export default props => {
  const router = useRouter()
  if (props.type === 'Web' || props.type === 'Media') {
    return (
      <Link href={props.url} target={props.target} prefetch={false}>
        {props.label || props.children}
      </Link>
    )
  } else if (props.type === 'Document') {
    return (
      <Link href={`/${props.lang}/${props.uid}`} prefetch={false}>
        {props.children}
      </Link>
    )
  } else if (props.type === 'internal') {
    return (
      <Link href={`/${router.query.lang}${props.route}`} prefetch={false}>
        {props.children}
      </Link>
    )
  } else if (props.type === 'page') {
    return (
      <Link href={PrismicLink.url(props.link, linkResolver)} prefetch={false}>
        {props.children}
      </Link>
    )
  } else {
    console.warn('Note: Most likely a wrong link type was used.')
    return null
  }
}
